import { BlueBlob, FormattedMessageDiv } from '@odmonorepo/core-components';
import { Row, Tab } from 'react-bootstrap';
import { useEffect, useState } from 'react';
import IFDebitCardDetails from '../../Features/InstantFunding/IFDebitCardDetails';
import IFLandingCard from '../../Features/InstantFunding/IFLandingCard';
import IFrameCard from '../../Features/InstantFunding/IFrameCard';
import { useNavigate } from '@tanstack/react-router';
import { useLOC } from 'merchant-api/spiceroad';


export const InstantFunding = () => {
  const [activeTab, setActiveTab] = useState('landing');
  const [registrationError, setRegistrationError] = useState(false);
  const [authorizedUrl, setAuthorizedUrl] = useState('');
  const navigate = useNavigate();
  const { cardRegistered } = useLOC();

  useEffect(() => {
    if (cardRegistered && activeTab !== 'success') {
      navigate({to: '/'});
    }
  }, [cardRegistered, navigate]);

  return (
    <>
      <BlueBlob>
        <Row>
          <h1 className="h2 mb-6 text-center">
            <FormattedMessageDiv id={'instantFunding.title'} />
          </h1>
        </Row>
      </BlueBlob>

      <Tab.Container
        mountOnEnter={true}
        unmountOnExit={true}
        activeKey={activeTab}
      >
        <Tab.Content>
          <Tab.Pane eventKey={'landing'}>
            <IFLandingCard
              onContinue={() => setActiveTab('iFrame')}
              setAuthorizedUrl={setAuthorizedUrl}
              registrationError={registrationError}
              setRegistrationError={setRegistrationError}
            />
          </Tab.Pane>
          <Tab.Pane eventKey={'iFrame'}>
            <IFrameCard
              setActiveTab={setActiveTab}
              setRegistrationError={setRegistrationError}
              authorizedUrl={authorizedUrl}
            ></IFrameCard>
          </Tab.Pane>
          <Tab.Pane eventKey={'success'}>
            <IFDebitCardDetails />
          </Tab.Pane>
        </Tab.Content>
      </Tab.Container>
    </>
  );
};

export default InstantFunding;
